// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Typography, Skeleton } from '@mui/material';
import { isNil } from 'lodash';

import PeriodRangeSlider from '../shared/PeriodRangeSlider';

import { useDispatch, useSelector } from '../../redux/store';
import { setCurrentPeriod } from '../../redux/slices/frontend';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(() => ({
  width: '100%'
  // top: theme.spacing(12)
  // right: theme.spacing(1),
  // padding: theme.spacing(1)
}));

// ----------------------------------------------------------------------

export default function FrontEndMainPeriodSelector() {
  const dispatch = useDispatch();
  const { publishedPeriods, currentPeriod } = useSelector((state) => state.frontend);

  const setCurrentFrontEndPeriod = (period) => {
    dispatch(setCurrentPeriod(period));
  };

  return (
    <RootStyle>
      <Box
        sx={{
          borderRadius: 1.5,
          paddingTop: 1,
          paddingLeft: 1.5,
          paddingRight: 1.5,
          paddingBottom: 0,
          color: 'common.white',
          backgroundColor: (theme) => alpha(theme.palette.grey[200], 0.95)
        }}
      >
        {isNil(currentPeriod) || isNil(currentPeriod.start) || isNil(currentPeriod.start.label) ? (
          <>
            <Skeleton animation="wave" height={30} width="100%" />
            <Skeleton animation="wave" height={20} width="100%" />
          </>
        ) : (
          <>
            <Typography variant="body2" sx={{ textAlign: 'center', color: 'common.black' }}>
              {`${currentPeriod.start.label} -- ${currentPeriod.end.label}`}
            </Typography>
            <PeriodRangeSlider
              sliderType="Range"
              publishedPeriods={publishedPeriods.filter((pp) => pp.kind === 'DataElement')}
              currentPeriod={currentPeriod}
              setCurrentPeriod={setCurrentFrontEndPeriod}
              valueLabelDisplay="auto"
            />
          </>
        )}
      </Box>
    </RootStyle>
  );
}
